import React from 'react'
import styled from 'styled-components'
import {InnerLayout } from '../styles/Layouts'
import ProgressBar from './ProgressBar'
import Title from './Title'

function Skills() {
    return (
        <SkillsStyled>
                <Title title={'My Skills'} span={'My Skills'}/>
                <InnerLayout>
                    <div className="skills">
                        <ProgressBar 
                         title={'HTML5'}
                         width={'70%'}
                         text={'70%'}                        
                        />
                         <ProgressBar 
                         title={'CSS3'}
                         width={'70%'}
                         text={'70%'}                        
                        /> 
                        <ProgressBar 
                         title={'Javascript'}
                         width={'85%'}
                         text={'85%'}                        
                        />
                         <ProgressBar 
                         title={'Python'}
                         width={'65%'}
                         text={'65%'}                        
                        />
                         <ProgressBar 
                         title={'React JS'}
                         width={'90%'}
                         text={'90%'}                        
                        />
                        <ProgressBar 
                         title={'SharePoint Online'}
                         width={'85%'}
                         text={'85%'}                        
                        />
                    </div>
                </InnerLayout>

            
        </SkillsStyled>
    )
}

const SkillsStyled = styled.section`
 
.skills{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    grid-column-gap: 1rem;
    grid-row-gap: 1.2rem;
     @media screen and (max-width: 700px){
            grid-template-columns: repeat(1, 1fr);
        }
}

`;


export default Skills
